<template>
  <transition name="loginPopup">
    <div class="popup-back login-popup">
      <section class="popup">
        <h1 class="popup-title" tabindex="1">로그인 팝업</h1>
        <div class="popup-button-close">
          <a href="#" @click.prevent="closeLoginPopup()">
            <img src="../../assets/images/common/btn-popup-close.svg" alt="팝업 닫기">
          </a>
        </div>
        <div class="login member-layout">
          <h2 tabindex="0">로그인</h2>
          <div class="join-sns-box">
            <h3 class="login-box-hd wavve-hd" tabindex="0">Wavve 계정으로 로그인</h3>
            <form>
              <fieldset>
                <legend>로그인 양식</legend>
                <ul class="input-wrap01">
                  <li>
                    <label>
                      <input type="text" v-model="usrId" @keydown.enter="login()"
                           placeholder="이메일 주소 또는 아이디" title="아이디" class="input-style01">
                    </label>
                    <p v-if="checkIdMsg !== ''" class="login-error-red">{{checkIdMsg}}</p>
                  </li>
                  <li>
                    <label>
                      <input type="password" v-model="usrPwd" @keydown.enter="login()"
                           placeholder="비밀번호" title="비밀번호" class="input-style01">
                    </label>
                    <p v-if="checkPwdMsg !== ''" class="login-error-red">{{checkPwdMsg}}</p>
                    <p v-if="loginMsg !== ''" class="login-error-red" v-html="loginMsg"></p>
                  </li>
                </ul>
                <ul class="checkbox-wrap01">
                  <li class="check-style check-style-dark">
                    <input type="checkbox" v-model="saveId" id="id-save" class="check-blue-dark">
                    <label for="id-save">아이디 저장</label>
                  </li>
                  <li class="check-style check-style-dark">
                    <input type="checkbox" @click="setAutoLogin()" id="login-auto" class=" check-blue-dark">
                    <label for="login-auto">자동 로그인</label>
                  </li>
                </ul>
                <div class="btn-purple btn-purple-dark">
                  <a href="#" @click.prevent="login()">로그인</a>
                </div>
              </fieldset>
            </form>
            <ul class="join-find">
              <li>
                <a href="https://member.wavve.com/find/id">아이디 찾기</a>
              </li>
              <li>
                <a href="https://member.wavve.com/find/password">비밀번호 재설정</a>
              </li>
              <li>
                <a href="https://member.wavve.com/account">회원가입</a>
              </li>
            </ul>
          </div>
          <div class="sns-box">
            <div class="or-bar-box">
              <span class="or-bar or-bar-left"></span>
              <h3 class="login-box-hd" tabindex="0">또는 다른 서비스 계정으로 로그인</h3>
              <span class="or-bar or-bar-right"></span>
            </div>
            <div class="login-sns">
              <ul>
                <btn-kakao/>
                <btn-skt/>
                <btn-naver/>
                <btn-facebook/>
                <btn-apple/>
              </ul>
            </div>
            <p class="sns-exclamation">
              <span>SNS계정으로 간편하게 가입하여 서비스를 이용하실 수 있습니다.</span>
              <span>기존 POOQ 계정 또는 Wavve 계정과는 연동되지 않으니 이용에 참고하세요.</span>
            </p>
          </div>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
import BtnFacebook from '@/components/member/BtnFacebook'
import BtnKakao from '@/components/member/BtnKakao'
import BtnNaver from '@/components/member/BtnNaver'
import BtnSkt from '@/components/member/BtnSkt'
import BtnApple from '@/components/member/BtnApple'
import { loginProc } from '@/common/utils/login'
import cookie from '@/common/utils/cookie'
import { needSelectProfile } from '@/common/utils/common'
import { mapMutations } from 'vuex'
import { SOCIAL_LOGIN_SUCCESS_EVENT } from '@/common/resources/const'
import { PATH_NAME_PROFILE_LIST } from '@/common/resources/router.const'

export default {
  components: {
    BtnFacebook,
    BtnKakao,
    BtnNaver,
    BtnSkt,
    BtnApple
  },
  props: {
    closeLoginPopup: {
      type: Function
    }
  },
  data () {
    return {
      userType: 'general',
      usrId: '',
      usrPwd: '',
      saveId: false,
      autoLogin: false,
      loginMsg: '',
      checkIdMsg: '',
      checkPwdMsg: '',
      referer: '/index.html'
    }
  },
  methods: {
    ...mapMutations(['hideLoginPopup']),
    url (url) {
      return location.protocol + '//' + url
    },
    pageMove (pageUrl) {
      window.location.href = (typeof pageUrl === 'undefined' || pageUrl === '') ? this.referer : pageUrl
    },
    setAutoLogin () {
      this.autoLogin = !this.autoLogin
    },
    isValidation () {
      let loginCheck = true
      if (!this.usrId || this.usrId.trim().length <= 0) {
        this.checkIdMsg = '이메일 또는 아이디를 입력해주세요.'
        loginCheck = false
      } else if (!this.usrPwd || this.usrPwd.trim().length <= 0) {
        this.checkPwdMsg = '비밀번호를 입력해주세요.'
        loginCheck = false
      }
      return loginCheck
    },
    login () {
      if (this.isValidation()) {
        loginProc({ userType: this.userType, userId: this.usrId, userPassword: this.usrPwd, saveId: this.saveId, autoLogin: this.autoLogin })
          .then((data) => {
            this.hideLoginPopup()
            if (needSelectProfile(data)) {
              this.$router.push({
                name: PATH_NAME_PROFILE_LIST,
                query: {
                  referer: this.$route.fullPath
                }
              })
            } else {
              location.replace(location.href)
              // this.$router.push(changeReferer(this.$route.fullPath))
              // this.$events.$emit('loginSuccess')
            }
          }).catch((error) => {
            alert(error.response.data.resultmessage.replace('\\\\n', '<br/>'))
            this.loginMsg = error.response.data.resultmessage.replace('\\\\n', '<br/>')
              .replace('\\n', '<br/>')
          })
      }
    }
  },
  created () {
    // 소셜 로그인 이벤트 등록
    this.$events.$on(SOCIAL_LOGIN_SUCCESS_EVENT, () => {
      window.location.reload()
    })

    let saveUserId = cookie.getSaveUserId()
    // 아이디 저장 체크
    if (saveUserId !== 'none') {
      this.usrId = saveUserId
      this.saveId = true
    }
  },
  beforeDestroy () {
    this.$events.$off(SOCIAL_LOGIN_SUCCESS_EVENT)
  },
  watch: {
    usrId () {
      if (this.usrId.length > 0) this.checkIdMsg = ''
    },
    usrPwd () {
      if (this.usrPwd.length > 0) this.checkPwdMsg = ''; this.loginMsg = ''
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/member.scss"></style>

<style>
/* login */
.login ul.checkbox-wrap01 li{
  font-size: 0px;
}

.login ul.join-find{
  margin: 20px auto 50px;
}

.login ul.join-find li a{
  padding: 0 14px;
}

.login ul.join-find li:first-child a{
  padding-left: 0;
 }

.login ul.join-find li:last-child a{
  padding-right: 0;
}

/* 로그인 팝업 */
.popup-back .popup{
  position: absolute;
  top: 50%;
  left: 50%;
}

.login-popup .popup{
  margin-top: -383px;
  margin-left: -280px;
}

.popup-button-close{
  right: -38px;
}

.popup-button-close a{
  display: block;
}

.loginPopup-enter-active, .loginPopup-leave-active{
  transition: opacity .3s
}

.loginPopup-enter, .loginPopup-leave-to{ /* .fade-leave-active below version 2.1.8 */
  opacity: 0
}
</style>
